import { Button, Dropdown, Menu, Table } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Pagination, { PaginationProps } from "antd/es/pagination";
import { LoadingOutlined } from "@ant-design/icons";
import { RootState } from "../../redux/rootReducer";
import { resetUsers, retrieveUsers } from "../../redux/actions/userActions";
import { Actions, PageSize } from "../../shared/constant";
import tableUtils from "../../utils/tableUtils";
import { UserColumn } from "../../shared/table/columns";
import icons from "../../shared/icons";
import UserModalForm from "../../components/Users/UserModalForm";
import SearchComponent from "../../components/_shared/SearchComponent";
import { getAllClients } from "../../redux/actions/accountActions";
import { isClapAdminORClapManager } from "../../utils/clapUtils";

function Users() {
  const [visible, setVisible] = useState(false);
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const [mode, setMode] = useState("");
  const [editData, setEditData] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [effect, setEffect] = useState(false);
  const { users, count, userDetails, usersPending } = useSelector(
    (state: RootState) => state.user,
  );

  useEffect(() => {
    dispatch(resetUsers());
    dispatch(getAllClients());
  }, []);

  useEffect(() => {
    dispatch(
      retrieveUsers({
        page,
        searchText,
      }),
    );
  }, [page, effect]);

  const handlePageChange: PaginationProps["onChange"] = (p) => {
    setPage(p);
  };

  const handleSearch = (value: string) => {
    setSearchText(value);
    setPage(1);
    setEffect(!effect);
  };

  const onCreate = () => {
    setMode(Actions.CREATE);
    setVisible(true);
  };

  const hideModal = () => {
    setVisible(false);
    setEffect(!effect);
    // TODO change this effect from here; also in label
  };

  const onEdit = (record: any) => {
    setMode(Actions.EDIT);
    setVisible(true);
    setEditData(record);
  };

  // TODO can reuse actions for every dropdown
  // notes: clap manager can't delete user
  const actions = {
    title: "",
    key: "action",
    align: "right",
    render: (_: any, record: any) =>
      isClapAdminORClapManager(userDetails) && (
        <div className="text-secondary">
          <Dropdown
            overlay={
              <Menu
                className="min-w-[100px] rounded-[3px]"
                items={[
                  {
                    label: (
                      <div onClick={() => onEdit(record)} aria-hidden="true">
                        Edit
                      </div>
                    ),
                    key: "EDIT",
                  },
                ]}
              />
            }
            trigger={["click"]}
          >
            <button type="button">{icons.DotsVerticle()}</button>
          </Dropdown>
        </div>
      ),
  };

  return (
    <div>
      <div className="flex justify-between items-center">
        <div className="text-heading20">Users</div>
        <div>
          <Button type="primary" onClick={onCreate}>
            Create User
          </Button>
          <UserModalForm
            visible={visible}
            onCancel={hideModal}
            mode={mode}
            editData={editData}
          />
        </div>
      </div>
      <div className="mt-5 mb-4">
        <div>
          <SearchComponent handleSearch={handleSearch} />
        </div>
      </div>
      <div>
        <Table
          rowKey={(record: any) => {
            return record.id;
          }}
          columns={tableUtils.buildColumns(users, UserColumn, actions)}
          dataSource={users}
          pagination={false}
          size="middle"
          scroll={{ x: 1024 }}
          loading={{
            spinning: usersPending as boolean,
            indicator: <LoadingOutlined style={{ fontSize: 34 }} />,
          }}
        />
      </div>
      <div className="text-right mt-4">
        <Pagination
          current={page}
          pageSize={PageSize.DEFAULT}
          onChange={handlePageChange}
          total={count}
          showSizeChanger={false}
        />
      </div>
    </div>
  );
}

export default Users;
